import { service } from '@ember/service';
import { findRecord } from '@ember-data/legacy-compat/builders';
import AuthenticatedRoute from 'cpc-license-manager/utils/authenticated-route';

export default class OrganizationRoute extends AuthenticatedRoute {
  @service store;

  async model(params) {
    const licenses = await this.store.query('license', { organization: params.id });
    const { content: organization } = await this.store.request(findRecord('organization', params.id));

    return {
      licenses,
      organization,
    };
  }

  setupController(controller, { licenses, organization }) {
    Object.assign(controller, {
      totalRecords: licenses.meta.count ?? 0,
      model: organization,
    });
  }
}
